import React, { useEffect, useState } from "react";
import Modal from "../../Modal/Modal";
import axiosService from "../../../utils/AxiosService";
import NewInfluencerModashForm from "./NewInfluencerForms/NewInfluencerModashForm";
import AttachExistingAuthenticationForm from "./NewInfluencerForms/AttachExistingAuthenticationForm";
import ManualAuthenticationForm from "./NewInfluencerForms/ManualAuthenticationForm";
import InfoTooltip from "../../FormComponents/InfoTooltip";

export default function NewAuthenticationModal({ isOpen, setIsOpen, infId, authentications = [], initialMode = 'pull', initialProvider = '', onAuthenticationsChanged = () => {} }) {
  const [credits, setCredits] = useState()
  const [mode, setMode] = useState('pull')
  const [manualProvider, setManualProvider] = useState(initialProvider)
  const [manualDrafts, setManualDrafts] = useState({})

  const getCredits = () => {
    axiosService.get('/api/project_manager/modash/credits')
    .then(credits => setCredits(credits))
    .catch((error) => console.log(error))
  }

  useEffect(() => getCredits(),[])
  useEffect(() => {
    if (!isOpen) return
    setMode(infId ? (initialMode || 'pull') : 'pull')
    setManualProvider(initialProvider || '')
    setManualDrafts({})
  }, [isOpen])

  const hasUnsavedManualDrafts = Object.values(manualDrafts).some(draft => draft.dirty)

  const closeModal = () => {
    if (hasUnsavedManualDrafts && !window.confirm('You have unsaved account data. Discard it?')) return
    setIsOpen(false)
  }

  return (
    <Modal isOpen={isOpen} onClose={closeModal} maxHeight={'calc(100vh - 32px)'}>
      <Modal.Header>
        <span className="font-bold dark:text-white">Add new social media account</span>
      </Modal.Header>
      <Modal.Body>
        <div className="min-w-[500px]">
          {credits && <p className="text-sm text-gray-500 dark:text-gray-400 -mt-2 mb-2">Remaining Credits: <span className="font-bold bg-rb-grey dark:bg-rb-dark-mode-lighter dark:text-white rounded-md px-2 py-1">{credits}</span></p>}
          <div className="flex gap-4 w-full border-b-1 dark:border-rb-dark-mode-lighter">
            <button type="button" className={`pb-1 dark:text-white ${mode === 'pull' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setMode('pull')}>Pull a new account</button>
            {infId && (
              <button type="button" className={`pb-1 dark:text-white ${mode === 'manual' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setMode('manual')}>
                <span className="inline-flex items-center gap-1">
                  Create manually
                  <InfoTooltip text="Not synced with Modash - enter and keep this account's stats up to date by hand. Use this for creators too small for Modash to track yet." />
                </span>
              </button>
            )}
            {infId && (
              <button type="button" className={`pb-1 dark:text-white ${mode === 'attach' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setMode('attach')}>
                <span className="inline-flex items-center gap-1">
                  Attach an existing account
                  <InfoTooltip text="Finds an account that already exists elsewhere and re-parents it onto this influencer. Nothing new is pulled from Modash." />
                </span>
              </button>
            )}
          </div>
          {mode === 'pull' && <NewInfluencerModashForm setIsOpen={setIsOpen} infId={infId} />}
          {mode === 'manual' && infId && <ManualAuthenticationForm
              setIsOpen={setIsOpen}
              onCancel={closeModal}
              infId={infId}
              authentications={authentications}
              provider={manualProvider}
              setProvider={setManualProvider}
              drafts={manualDrafts}
              setDrafts={setManualDrafts}
              onSuccess={onAuthenticationsChanged}
            />}
          {mode === 'attach' && infId && <AttachExistingAuthenticationForm setIsOpen={setIsOpen} infId={infId} />}
        </div>
      </Modal.Body>
    </Modal>
  );
}
